module.exports = __webpack_public_path__ + "static/media/progress.ba14ef03.svg";